import { useQuery } from "urql";

import {
  ClikNotGrantedContractFilter,
  ClikNotGrantedContractOrderBy,
  GetClikNotGrantedContractDocument,
} from "../../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../../utils/api.ts";
import { ApiHookProps } from "../../types.ts";

export const useClikNotGrantedContract = ({
  filter,
  orderBy,
  page,
}: ApiHookProps<
  ClikNotGrantedContractFilter,
  ClikNotGrantedContractOrderBy
>) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({ query: GetClikNotGrantedContractDocument, variables });
};
